// Helpers that resolve a match's MatchEvent ('3v3' | '1v1') from its kind +
// id. Quals carry the event in `kind` (qual_3v3 / qual_1v1). Playoff matches
// share four kinds (playoff_ub / lb / gf / gfr) across both events; the
// generate_bracket RPC namespaces them with id prefixes (`U_*` for 3v3,
// `E_*` for 1v1). Anything else (arctic / ec / unrecognized) returns null.
//
// Used by SupabaseStore.fetchAll to bucket matches into matches3v3 /
// matches1v1 and to resolve which live/on-deck slot to compare a match
// against. Bug here would scramble the live/on-deck markers + bracket UI.

import type { MatchEvent } from '../types';

export const PLAYOFF_KINDS = [
  'playoff_ub', 'playoff_lb', 'playoff_gf', 'playoff_gfr',
] as const;
const PLAYOFF_KIND_SET = new Set<string>(PLAYOFF_KINDS);

export function isPlayoffKind(kind: string): boolean {
  return PLAYOFF_KIND_SET.has(kind);
}

export function eventOfMatch(row: { id: string; kind: string }): MatchEvent | null {
  if (row.kind === 'qual_3v3') return '3v3';
  if (row.kind === 'qual_1v1') return '1v1';
  if (isPlayoffKind(row.kind)) {
    if (row.id.startsWith('U_')) return '3v3';
    if (row.id.startsWith('E_')) return '1v1';
  }
  return null;
}
